import { Link } from "react-router-dom";

export interface TopicRowData {
  id: string;
  title: string;
  boardName: string;
  author: string;
  createdAt: string;
  replies: number;
  views: number;
  likes: number;
}

export default function TopicRow({ topic, rank }: { topic: TopicRowData; rank?: number }) {
  return (
    <article className="flex items-start gap-3 border-b border-background-200 py-4 last:border-b-0">
      {typeof rank === "number" && (
        <span
          className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-semibold ${
            rank <= 3
              ? "bg-accent-500 text-background-50"
              : "bg-background-200 text-foreground-600"
          }`}
        >
          {rank}
        </span>
      )}
      <div className="min-w-0 flex-1">
        <h3 className="text-sm font-medium leading-snug text-foreground-950 md:text-[15px]">
          <Link to={`/topic/${topic.id}`} className="transition-colors hover:text-primary-700">
            {topic.title}
          </Link>
        </h3>
        <div className="mt-1.5 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
          <span className="rounded-md bg-secondary-100 px-1.5 py-0.5 text-secondary-800">
            {topic.boardName}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-user-3-line" />
            {topic.author}
          </span>
          <span className="hidden items-center gap-1 sm:flex">
            <i className="ri-time-line" />
            {topic.createdAt}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-chat-smile-2-line" />
            {topic.replies}
          </span>
          <span className="hidden items-center gap-1 sm:flex">
            <i className="ri-fire-line" />
            {topic.views}
          </span>
        </div>
      </div>
    </article>
  );
}